<template>
  <div>
    <Main
            :typesubjects='typesubjects'
            :housingstatus='housingstatus'
            :cashsettings='cashsettings'
            :maritalstatus='maritalstatus'
            :positions="positions"
            :employerownership="employerownership"
            :regions="regions"
            :activities="activities"
            :taxsystem="taxsystem"
            :activitieskind="activitieskind"
            :timer="timer"
            :summin="summin"
            :summax="summax"
            :termmin="termmin"
            :termmax="termmax"
            :periodforfop3="periodforfop3"
            :cookie="cookie"
            :quarterperiod="quarterperiod"
            :abandoned="abandoned"
            :clientyearmin="clientyearmin"
            :clientyearmax="clientyearmax"
            :percentrates="percentrates"
            :creditBetween="creditBetween"
            :monthBetween="monthBetween"
    ></Main>
  </div>
</template>


<script>
    import Main from './components/Main';

    export default {
        name: 'cash-landing',
        components: {
            Main
        },
        props: [
            'typesubjects',
            'housingstatus',
            'cashsettings',
            'maritalstatus',
            'positions',
            'timer',
            'cookie',
            'employerownership',
            'activities',
            'regions',
            'activitieskind',
            'taxsystem',
            'summin',
            'summax',
            'termmin',
            'termmax',
            'periodforfop3',
            'quarterperiod',
            'abandoned',
            'clientyearmin',
            'clientyearmax',
            'percentrates',
            'creditBetween',
            'monthBetween'
        ]
    }
</script>

